<template>
  <div class="page_content job-applications-page">
    <div class="row page-heading pg_hd pg_toolbar">
      <div class="col-12 input module_heading">
        <div class="header-left">
          <span class="module_icon ic2_job-application"></span>
          <h1 class="head_txt module_type_name ace_sec_hd" role="heading" aria-level="1">
            {{ $t('myJobApplications') }} [{{ filteredApplications.length }}]
          </h1>
          <div class="applications-filters">
            <b-button @click.stop="toggleFiltersDropDown" id="applicationsStatusDropDown" class="form-field application-status-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">Select Application Status</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="applicationsFiltersPopup" class="explore_filter_container"></div>
            <b-popover target="applicationsStatusDropDown" :show.sync="showFiltersDropDown" container="applicationsFiltersPopup" triggers="blur">
              <div class="field-row" v-for="statusValue in statusArray" :key="'filter-' + statusValue">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" :id="'application-filter-' + statusValue" :value="statusValue" v-model="statusFilterDraft" @click.stop @input.stop>
                  <label class="form-check-label" :for="'application-filter-' + statusValue">{{ statusValue }} </label>
                </div>
              </div>
              <b-btn @click="filtersOkClicked" class="range-button">ok</b-btn>
            </b-popover>
          </div>
          <div class="applications-filters">
            <b-button @click.stop="toggleEmployerDropDown" id="applicationsEmployerDropDown" class="form-field employer-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">{{ $t('employerFilter') }}</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="applicationsEmployerPopup" class="explore_filter_container"></div>
            <b-popover target="applicationsEmployerDropDown" :show.sync="showEmployerDropDown" container="applicationsEmployerPopup" triggers="blur">
              <div class="popup_content">
                <input type="text" class="input-search" :placeholder="$t('typeToFilterEmployer')" :aria-label="$t('typeToFilterEmployer')" v-model.trim="employerSearch">
                <div class="field-row" v-for="(employerName, index) in filteredEmployers" :key="'employer-filter-' + employerName">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" :id="'application-employer-filter-' + index" :value="employerName" v-model="employerFilterDraft" @click.stop @input.stop>
                    <label class="form-check-label" :for="'application-employer-filter-' + index">{{ employerName }}</label>
                  </div>
                </div>
              </div>
              <b-btn @click="employerOkClicked" class="range-button">{{ $t('ok') }}</b-btn>
            </b-popover>
          </div>
        </div>
        <div class="toolbar-right">
          <!--
          <div class="out-of-total-item ace_sec_txt">
            <div>{{ filteredApplications.length }} applications</div>
          </div>
          -->
          <div class="number-of-item ace_sec_txt">
            <b-dropdown id="applicationsSizeDropdown" :text="'' + pageSize" aria-label="number of item">
              <template v-for="(option, index) in sizeOptions">
                <b-dropdown-divider v-if="index > 0" :key="'divider-' + option"></b-dropdown-divider>
                <b-dropdown-item :key="'size-' + option" @click="changeSize(option)">{{ option }} {{ $t('itemPerPage') }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="pagination btn_container pagination_sty3">
            <button type="button" class="btn btn_trans" :disabled="firstPage" @click="prev" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="current-page ace_sec_txt">{{ page + 1 }}</span>
            <button type="button" class="btn btn_trans" :disabled="lastPage" @click="next" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>

          <div class="search-box-container">
            <input type="text" class="input-search" placeholder="type to narrow results" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" aria-label="type to narrow results">
            <button class="btn btn_srh" @click="searchButtonClicked" aria-label="go">
              <span class="ic_srh ic_search"></span>
            </button>
            <button id="applicationsSortByDropDown" type="button" @click="toggleSortByDropDown" class="sort-by ace_sec" style="margin-left: 15px;">
              <span class="ic2_sort2 sort-by-icon"></span>
              <span class="txt_srt">sort</span>
            </button>
            <div id="applicationsSortPopup" class="sort_by_popover"></div>
          </div>
          <b-popover target="applicationsSortByDropDown" :show.sync="showSortByDropDown" container="applicationsSortPopup" triggers="blur">
            <div class="header-content-row">
              <span class="title">Sort by</span>
            </div>
            <template v-for="sort in sorts">
              <div class="field-row" :key="sort.name">
                <div class="form-check">
                  <input type="radio" class="form-check-input" :id="'application-sort-' + sort.name" v-model="selectedSortName" :value="sort.name">
                  <label class="form-check-label" :for="'application-sort-' + sort.name">{{ sort.name }}</label>
                </div>
              </div>
            </template>
            <b-btn @click="sortOkClicked" class="range-button">ok</b-btn>
          </b-popover>
        </div>
      </div>
    </div>
    <b-input-group class="job-board-filter-tags filter-tags-wrapper">
      <div
        class="search_tag filter-tag"
        v-for="(statusValue, index) in statusFilterSelected"
        :key="'status-filter-' + statusValue">
        <span class="title application-status-tag">{{ statusValue }}</span>
        <span
          class="ic_btn ic_bin"
          :aria-label="$t('deleteAria')"
          tabindex="0"
          @click.stop="removeStatusFilter(index)"
          @keydown.enter.prevent="removeStatusFilter(index)">
        </span>
      </div>
      <div
        class="search_tag filter-tag"
        v-for="(employerName, index) in employerFilterSelected"
        :key="'employer-filter-tag-' + employerName">
        <span class="title employer-tag">{{ employerName }}</span>
        <span
          class="ic_btn ic_bin"
          :aria-label="$t('deleteAria')"
          tabindex="0"
          @click.stop="removeEmployerFilter(index)"
          @keydown.enter.prevent="removeEmployerFilter(index)">
        </span>
      </div>
    </b-input-group>
    <div class="course-management-section">
      <div class="applications-list-container">
        <div v-if="pagedApplications.length > 0" class="applications-list">
          <div
            class="application-row"
            v-for="(application, index) in pagedApplications"
            :key="applicationKey(application, index)"
            :class="{ 'is-expanded': isExpanded(application, index) }">
            <div class="application-row-main">
              <div class="application-job">
                <b-link
                  v-if="application.jobId"
                  class="job-title ace_sec_txt"
                  :to="{ name: 'jobHome', params: { uuid: application.jobId } }">
                  {{ application.jobTitle }}
                </b-link>
                <span v-else class="job-title ace_sec_txt">{{ application.jobTitle }}</span>
              </div>
              <div class="application-employer">
                <div
                  class="employer-avatar"
                  :class="{ 'has-logo': employerLogo(application) }"
                  :style="employerLogo(application) ? null : { background: avatarColor(index) }">
                  <img
                    v-if="employerLogo(application)"
                    :src="employerLogo(application)"
                    :alt="application.employerTitle || ''">
                  <span v-else>{{ employerInitials(application.employerTitle) }}</span>
                </div>
                <div class="employer-name ace_sec_txt">{{ application.employerTitle }}</div>
              </div>
              <div class="application-status">
                <span class="status-path-icon" aria-hidden="true">
                  <span class="ic2_Process"></span>
                </span>
                <div class="status-boxes">
                  <div
                    class="status-box"
                    v-for="stage in statusStages"
                    :key="stage.key"
                    :class="{
                      'is-complete': isStageComplete(application, stage),
                      'is-rejected': isStageRejected(application, stage)
                    }"
                    :title="stage.label"
                    :aria-label="stage.label">
                  </div>
                </div>
              </div>
              <button
                type="button"
                class="expand-btn"
                :class="{ 'is-open': isExpanded(application, index) }"
                :aria-expanded="isExpanded(application, index) ? 'true' : 'false'"
                :aria-label="isExpanded(application, index) ? 'collapse application' : 'expand application'"
                @click="toggleExpand(application, index)">
                <span class="fa fa-angle-down"></span>
              </button>
            </div>
            <div class="application-row-details" v-if="isExpanded(application, index)">
              <template v-for="(stage, stageIndex) in statusStages">
                <div
                  class="expanded-status-box"
                  :key="'detail-' + stage.key"
                  :class="{
                    'is-complete': isStageComplete(application, stage),
                    'is-rejected': isStageRejected(application, stage),
                    'has-offer-actions': canRespondToOffer(application, stage)
                  }">
                  <template v-if="canRespondToOffer(application, stage)">
                    <div class="offer-actions">
                      <button type="button" class="offer-btn accept" @click.stop="confirmOfferResponse(application, 'accept')">Accept</button>
                      <button type="button" class="offer-btn decline" @click.stop="confirmOfferResponse(application, 'decline')">Decline</button>
                    </div>
                  </template>
                  <template v-else>
                    <span class="expanded-status-label">{{ stageDisplayLabel(application, stage) }}</span>
                    <span class="expanded-status-date">{{ stageDateLabel(application, stage) }}</span>
                  </template>
                </div>
                <span
                  class="status-box-separator"
                  v-if="stageIndex < statusStages.length - 1"
                  :key="'sep-' + stage.key"
                  aria-hidden="true">></span>
              </template>
            </div>
          </div>
        </div>
        <div v-else class="no-result ace_sec_txt">No Results Found</div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
              <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
          </div>
      </b-modal>
    </div>
    <b-modal class="modal__v22_2" ref="offerConfirmModal" no-close-on-backdrop no-close-on-esc centered>
      <div slot="modal-header" class="row header-section w-100">
        <div class="col-8 hd">
          <div class="ic_container"></div>
          <div class="hd_txt">
            <span>Please Confirm!</span>
          </div>
        </div>
        <div class="col-4 btn_container pr-0">
          <button class="btn_close" aria-label="close" @click="cancelOfferResponse">
            <span class="ic-close"></span>
          </button>
        </div>
      </div>
      <div class="row modal_msg_container">
        <div class="col-12 msg_sec">
          <span>{{ offerConfirmMessage }}</span>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-button @click="confirmOfferResponseYes" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
        <b-button @click="cancelOfferResponse" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import '../../../assets/module/sass/course/courseList.scss'

  export default {
    name: 'myJobApplications',
    data: () => {
      return {
        jobApplications: [],
        pageSize: 20,
        sizeOptions: [20, 50, 100],
        firstPage: true,
        lastPage: true,
        page: 0,
        searchTerms: '',
        appliedSearch: '',
        collapsedApplicationKeys: {},
        showFiltersDropDown: false,
        showEmployerDropDown: false,
        showSortByDropDown: false,
        statusFilterDraft: [],
        statusFilterSelected: [],
        employerFilterDraft: [],
        employerFilterSelected: [],
        employerSearch: '',
        selectedSortName: 'Job',
        sorts: [
          { name: 'Job' },
          { name: 'Employer' },
          { name: 'Applied On' },
          { name: 'Status' }
        ],
        statusArray: ['Applied', 'Reviewed', 'Interview Scheduled', 'Interview Done', 'Job Offered', 'Job Accepted'],
        statusStages: [
          { key: 'appliedOn', label: 'Applied', status: 'Applied' },
          { key: 'reviewedOn', label: 'Reviewed', status: 'Reviewed' },
          { key: 'interviewScheduledOn', label: 'Interview', status: 'Interview Scheduled' },
          { key: 'interviewedOn', label: 'Interviewed', status: 'Interview Done' },
          { key: 'offeredOn', label: 'Job Offer', status: 'Job Offered' },
          { key: 'acceptedOn', label: 'Job Acceptance', status: 'Job Accepted' }
        ],
        avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c'],
        offerResponseSaving: false,
        pendingOfferApplication: null,
        pendingOfferAction: ''
      }
    },
    mounted () {
      this.loadJobApplications()
    },
    methods: {
      ...mapActions([
        'getJobApplications',
        'updateJobApplicationUserStatus'
      ]),
      loadJobApplications () {
        this.showLoader()
        this.jobApplications = []
        this.getJobApplications().then(res => {
          this.jobApplications = this.normalizeApplications(res)
          this.page = 0
          this.updatePaging()
          this.hideLoader()
        })
      },
      normalizeApplications (res) {
        if (!res) {
          return []
        }
        if (res.content && res.content.length >= 0) {
          return res.content
        }
        if (res.length >= 0) {
          return res
        }
        if (res.status || res.jobId) {
          return [res]
        }
        return []
      },
      updatePaging () {
        let totalPages = Math.ceil(this.filteredApplications.length / this.pageSize)
        if (totalPages < 1) {
          totalPages = 1
        }
        if (this.page > totalPages - 1) {
          this.page = totalPages - 1
        }
        this.firstPage = this.page <= 0
        this.lastPage = this.page >= totalPages - 1
      },
      searchButtonClicked () {
        this.appliedSearch = this.searchTerms
        this.resetPage()
      },
      toggleFiltersDropDown () {
        this.statusFilterDraft = this.statusFilterSelected.slice()
        this.showFiltersDropDown = !this.showFiltersDropDown
      },
      filtersOkClicked () {
        this.statusFilterSelected = this.statusFilterDraft.slice()
        this.showFiltersDropDown = false
        this.resetPage()
      },
      removeStatusFilter (index) {
        this.statusFilterSelected.splice(index, 1)
        this.statusFilterDraft = this.statusFilterSelected.slice()
        this.resetPage()
      },
      toggleEmployerDropDown () {
        this.employerFilterDraft = this.employerFilterSelected.slice()
        this.employerSearch = ''
        this.showEmployerDropDown = !this.showEmployerDropDown
      },
      employerOkClicked () {
        this.employerFilterSelected = this.employerFilterDraft.slice()
        this.showEmployerDropDown = false
        this.employerSearch = ''
        this.resetPage()
      },
      removeEmployerFilter (index) {
        this.employerFilterSelected.splice(index, 1)
        this.employerFilterDraft = this.employerFilterSelected.slice()
        this.resetPage()
      },
      toggleSortByDropDown () {
        this.showSortByDropDown = !this.showSortByDropDown
      },
      sortOkClicked () {
        this.showSortByDropDown = false
        this.resetPage()
      },
      changeSize (option) {
        this.pageSize = option
        this.resetPage()
      },
      sortApplications (list) {
        let sorted = list.slice()
        let name = this.selectedSortName
        sorted.sort((a, b) => {
          if (name === 'Applied On') {
            return (this.applicationDate(b) || 0) - (this.applicationDate(a) || 0)
          }
          if (name === 'Status') {
            return (a.status || '').localeCompare(b.status || '')
          }
          if (name === 'Employer') {
            return (a.employerTitle || '').localeCompare(b.employerTitle || '')
          }
          return (a.jobTitle || '').localeCompare(b.jobTitle || '')
        })
        return sorted
      },
      resetPage () {
        this.page = 0
        this.updatePaging()
      },
      prev () {
        if (this.firstPage) {
          return
        }
        this.page -= 1
        this.updatePaging()
      },
      next () {
        if (this.lastPage) {
          return
        }
        this.page += 1
        this.updatePaging()
      },
      applicationDate (application) {
        if (!application) {
          return null
        }
        return application.creationTime || application.appliedTime || application.statusUpdatedTime || application.lastUpdatedTime
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      millisToDate (millis) {
        let parsed = this.parseDateTime(millis)
        return parsed && parsed.isValid ? parsed.toFormat('MM/dd/yyyy') : 'N/A'
      },
      parseDateTime (value) {
        if (value === undefined || value === null || value === '') {
          return null
        }
        if (typeof value === 'number') {
          return DateTime.fromMillis(value < 1e12 ? value * 1000 : value)
        }
        if (value instanceof Date) {
          return DateTime.fromJSDate(value)
        }
        if (typeof value === 'object') {
          return this.parseDateTime(value.epochMillis || value.millis || value.time || value.epochSecond)
        }
        let text = String(value).trim()
        if (!text) {
          return null
        }
        let parsed = DateTime.fromISO(text)
        if (parsed.isValid) {
          return parsed
        }
        parsed = DateTime.fromFormat(text, 'MM/dd/yyyy')
        if (parsed.isValid) {
          return parsed
        }
        parsed = DateTime.fromFormat(text, 'yyyy-MM-dd HH:mm:ss')
        if (parsed.isValid) {
          return parsed
        }
        let asNumber = Number(text)
        if (!isNaN(asNumber)) {
          return this.parseDateTime(asNumber)
        }
        return parsed
      },
      stageDateValue (application, stage) {
        if (!application || !stage) {
          return null
        }
        if (stage.key === 'acceptedOn' && this.isOfferDeclined(application)) {
          return application.declinedOn || application.statusUpdatedTime || application.lastUpdatedTime
        }
        let value = application[stage.key]
        if (stage.key === 'appliedOn' && !value) {
          value = this.applicationDate(application)
        }
        if (stage.key === 'offeredOn' && !value) {
          value = application.jobOfferedOn || application.offerDate || application.statusUpdatedTime || application.lastUpdatedTime
        }
        return value
      },
      stageDateLabel (application, stage) {
        if (!this.isStageComplete(application, stage) && !this.isStageRejected(application, stage)) {
          return 'N/A'
        }
        return this.millisToDate(this.stageDateValue(application, stage))
      },
      applicationKey (application, index) {
        if (!application) {
          return index
        }
        return application.uuid || application.applicationUuid || application.applicationId || application.jobId || index
      },
      toggleExpand (application, index) {
        let key = this.applicationKey(application, index)
        if (this.collapsedApplicationKeys[key]) {
          this.$delete(this.collapsedApplicationKeys, key)
          return
        }
        this.$set(this.collapsedApplicationKeys, key, true)
      },
      isExpanded (application, index) {
        return !this.collapsedApplicationKeys[this.applicationKey(application, index)]
      },
      employerInitials (title) {
        if (!title) {
          return ''
        }
        let first = title.trim().split(/\s+/)[0]
        if (first.length <= 4) {
          return first.toUpperCase()
        }
        return first.substring(0, 3).toUpperCase()
      },
      employerLogo (application) {
        if (!application) {
          return ''
        }
        return application.employerLogo || ''
      },
      avatarColor (index) {
        return this.avatarColors[index % this.avatarColors.length]
      },
      statusRank (status) {
        if (status === 'Accepted') {
          status = 'Job Accepted'
        }
        if (status === 'Offered' || status === 'Job Offer') {
          status = 'Job Offered'
        }
        if (status === 'Declined') {
          return this.statusRank('Job Offered')
        }
        let order = ['Applied', 'Reviewed', 'Interview Scheduled', 'Interview Done', 'Job Offered', 'Job Accepted']
        let index = order.indexOf(status)
        return index < 0 ? 0 : index
      },
      isOfferAccepted (application) {
        if (!application) {
          return false
        }
        return !!(application.acceptedOn || application.status === 'Accepted' || application.status === 'Job Accepted')
      },
      isOfferDeclined (application) {
        if (!application) {
          return false
        }
        return !!(application.declinedOn || application.status === 'Declined' || application.acceptedRejected || application.acceptanceStatus === 'Rejected' || application.acceptanceStatus === 'Declined')
      },
      isStageRejected (application, stage) {
        if (!application || !stage) {
          return false
        }
        if (stage.key === 'interviewScheduledOn') {
          return !!(application.interviewRejected || application.interviewScheduleStatus === 'Rejected')
        }
        if (stage.key === 'offeredOn') {
          return !!(application.offerRejected || application.offerStatus === 'Rejected')
        }
        if (stage.key === 'acceptedOn') {
          return this.isOfferDeclined(application)
        }
        return false
      },
      isStageComplete (application, stage) {
        if (!application || !stage) {
          return false
        }
        if (this.isStageRejected(application, stage)) {
          return false
        }
        if (stage.key === 'acceptedOn') {
          return this.isOfferAccepted(application)
        }
        if (application[stage.key]) {
          return true
        }
        return this.statusRank(application.status) >= this.statusRank(stage.status)
      },
      canRespondToOffer (application, stage) {
        if (!application || !stage || stage.key !== 'acceptedOn') {
          return false
        }
        if (this.isOfferAccepted(application) || this.isOfferDeclined(application)) {
          return false
        }
        return application.status === 'Job Offered' || this.statusRank(application.status) >= this.statusRank('Job Offered')
      },
      stageDisplayLabel (application, stage) {
        if (!stage) {
          return ''
        }
        if (stage.key === 'acceptedOn' && this.isOfferDeclined(application)) {
          return 'Declined'
        }
        if (stage.key === 'acceptedOn' && this.isOfferAccepted(application)) {
          return 'Accepted'
        }
        return stage.label
      },
      confirmOfferResponse (application, action) {
        this.pendingOfferApplication = application
        this.pendingOfferAction = action
        this.$refs.offerConfirmModal.show()
      },
      cancelOfferResponse () {
        this.pendingOfferApplication = null
        this.pendingOfferAction = ''
        this.$refs.offerConfirmModal.hide()
      },
      confirmOfferResponseYes () {
        let application = this.pendingOfferApplication
        let action = this.pendingOfferAction
        this.$refs.offerConfirmModal.hide()
        this.pendingOfferApplication = null
        this.pendingOfferAction = ''
        this.respondToOffer(application, action)
      },
      respondToOffer (application, action) {
        if (!application || this.offerResponseSaving) {
          return
        }
        let applicationId = application.uuid
        if (!applicationId) {
          return
        }
        let status = action === 'accept' ? 'Accepted' : 'Declined'
        this.offerResponseSaving = true
        this.updateJobApplicationUserStatus({ applicationId: applicationId, status: status }).then((response) => {
          this.offerResponseSaving = false
          let title = application.jobTitle || ''
          if (response) {
            this.applyOfferResponse(application, response)
            this.notifySuccess('Successfully updated application status for \'' + title + '\'')
          } else {
            this.notifyFailure('Unable to update application status for \'' + title + '\'')
          }
        }).catch(() => {
          this.offerResponseSaving = false
          this.notifyFailure('Unable to update application status for \'' + (application.jobTitle || '') + '\'')
        })
      },
      applyOfferResponse (application, response) {
        let updated = Object.assign({}, application)
        if (response && typeof response === 'object' && !Array.isArray(response)) {
          if (response.data && (response.data.status || response.data.uuid)) {
            updated = Object.assign(updated, response.data)
          } else {
            updated = Object.assign(updated, response)
          }
        }
        let key = application.uuid
        this.jobApplications = this.jobApplications.map((item) => {
          if (item.uuid === key) {
            return Object.assign({}, item, updated)
          }
          return item
        })
      },
      notifySuccess (text) {
        return this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        return this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      offerConfirmMessage () {
        if (this.pendingOfferAction === 'decline') {
          return 'Are you sure you want to decline this offer?'
        }
        return 'Are you sure you want to accept this offer?'
      },
      filteredApplications () {
        let list = this.jobApplications || []
        if (this.appliedSearch) {
          let term = this.appliedSearch.toLowerCase()
          list = list.filter((application) => {
            let title = application.jobTitle || ''
            let employer = application.employerTitle || ''
            return title.toLowerCase().indexOf(term) !== -1 || employer.toLowerCase().indexOf(term) !== -1
          })
        }
        if (this.statusFilterSelected && this.statusFilterSelected.length > 0) {
          list = list.filter((application) => {
            return this.statusFilterSelected.indexOf(application.status) !== -1
          })
        }
        if (this.employerFilterSelected && this.employerFilterSelected.length > 0) {
          list = list.filter((application) => {
            return this.employerFilterSelected.indexOf((application.employerTitle || '').trim()) !== -1
          })
        }
        return this.sortApplications(list)
      },
      employerOptions () {
        let names = []
        let seen = {}
        let applications = this.jobApplications || []
        applications.forEach((application) => {
          let name = (application.employerTitle || '').trim()
          if (name && !seen[name]) {
            seen[name] = true
            names.push(name)
          }
        })
        names.sort((a, b) => a.localeCompare(b))
        return names
      },
      filteredEmployers () {
        let term = (this.employerSearch || '').toLowerCase()
        if (!term) {
          return this.employerOptions
        }
        return this.employerOptions.filter((name) => {
          return name.toLowerCase().indexOf(term) !== -1
        })
      },
      pagedApplications () {
        let start = this.page * this.pageSize
        return this.filteredApplications.slice(start, start + this.pageSize)
      }
    }
  }
</script>

<style scoped>
  .job-applications-page {
    height: calc(100vh - 134px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .page-heading.pg_hd {
    flex: 0 0 auto;
    margin-bottom: 0;
    position: relative;
    z-index: 5;
    background: #fff;
  }

  .page-heading.pg_hd .module_heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    width: 100%;
    margin-top: 0;
    padding-right: 20px;
  }

  .header-left {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 0 1 auto;
    flex-wrap: nowrap;
  }

  .header-left .module_icon {
    float: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    font-size: 28px;
    line-height: 28px;
    margin: 0 8px 0 0 !important;
  }

  .page-heading.pg_hd .module_heading .head_txt {
    width: auto;
    max-width: none;
    min-width: 0;
    float: none;
    display: block;
    margin: 0;
    padding: 0;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .job-board-filter-tags .filter-tag .application-status-tag {
    background-color: #7ad8f0;
  }

  .job-board-filter-tags .filter-tag .employer-tag {
    background-color: #ffb0c4;
  }

  .course-management-section {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 0;
    padding: 0 20px 16px;
    overflow: hidden;
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-left: 16px;
    flex: 0 0 auto;
  }

  .applications-filters {
    position: relative;
    margin-left: 12px;
    margin-right: 0;
    flex-shrink: 0;
  }

  .applications-filters .form-field {
    padding: 0 10px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: none;
    color: #000 !important;
  }

  .applications-filters .form-field:hover,
  .applications-filters .form-field:focus,
  .applications-filters .form-field:active {
    color: #000 !important;
  }

  .applications-filters .form-field label,
  .applications-filters .form-field .txt_sh,
  .applications-filters .form-field {
    color: #000 !important;
  }

  .applications-filters .form-field label {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-bottom: 0;
  }

  .applications-filters .application-status-filter,
  .applications-filters .application-status-filter:hover,
  .applications-filters .application-status-filter:focus {
    background: #7ad8f0 !important;
    color: #000 !important;
  }

  .applications-filters .employer-filter,
  .applications-filters .employer-filter:hover,
  .applications-filters .employer-filter:focus {
    background: #ffb0c4 !important;
    color: #000 !important;
  }

  .applications-filters .explore_filter_container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 0;
  }

  .toolbar-right .out-of-total-item {
    margin-right: 10px;
    white-space: nowrap;
    font-size: 1rem;
    font-weight: 400;
  }

  .toolbar-right .number-of-item {
    margin-right: 10px;
  }
  .toolbar-right .number-of-item >>> .dropdown-toggle {
    height: 32px;
    padding: 0 12px;
    background-color: #8f8f8f;
    border: none;
    color: #000;
  }

  .toolbar-right .pagination {
    display: flex;
    align-items: center;
    margin-right: 12px;
    margin-top: 0;
    padding-top: 0;
  }



  .toolbar-right .search-box-container {
    display: flex;
    align-items: center;
    width: auto;
    float: none;
  }

  .toolbar-right .sort-by {
    margin-left: 8px;
    cursor: pointer;
  }

  .applications-list-container {
    width: 100%;
    height: 100%;
    min-width: 0;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .applications-list-container::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  .application-row {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    border-bottom: 1px solid #e6e6e6;
  }

  .application-row-main {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) 40px;
    align-items: center;
    column-gap: 24px;
    min-height: 64px;
    width: 100%;
    min-width: 0;
    padding: 14px 8px 14px 4px;
  }

  .application-job {
    min-width: 0;
  }

  .job-title {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #4a4a4a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .application-job a.job-title {
    text-decoration: none;
  }

  .application-job a.job-title:hover {
    text-decoration: underline;
  }

  .application-employer {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .employer-avatar {
    width: 80px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2px;
    overflow: hidden;
  }

  .employer-avatar.has-logo {
    background: transparent;
  }

  .employer-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .employer-name {
    font-size: 14px;
    font-weight: 400;
    color: #6a6a6a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .application-status {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
  }

  .status-path-icon {
    width: 28px;
    min-width: 28px;
    height: 18px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .status-boxes {
    display: flex;
    align-items: center;
  }

  .status-box {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    border-radius: 2px;
    background: #e6e6e6;
  }

  .status-box.is-complete {
    background: #c8e6c0;
  }

  .status-box.is-rejected {
    background: #e8b4b4;
  }

  .expand-btn {
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    padding: 0;
    border: 1px solid #d4d4d4;
    border-radius: 50%;
    background: #fff;
    color: #8a8a8a;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    justify-self: end;
    box-shadow: none;
    line-height: 1;
  }

  .expand-btn:hover,
  .expand-btn:focus {
    background: #f7f7f7;
    outline: none;
  }

  .expand-btn .fa {
    font-size: 16px;
    line-height: 1;
    transition: transform 0.15s ease;
  }

  .expand-btn.is-open .fa {
    transform: rotate(180deg);
  }

  .application-row-details {
    display: flex;
    align-items: stretch;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 8px 72px 20px 4px;
  }

  .expanded-status-box {
    flex: 1 1 0;
    min-width: 0;
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 16px;
    background: #c4c4c4;
    color: #000;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  }

  .status-box-separator {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    margin: 10px 5px;
    color: #8a8a8a;
    font-size: 26px;
    font-weight: 600;
    line-height: 1;
  }

  .expanded-status-box.is-complete {
    background: #c8e6c0;
  }

  .expanded-status-box.is-rejected {
    background: #c97a7a;
  }

  .expanded-status-label {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    color: #000;
  }

  .expanded-status-date {
    margin-top: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.2;
    color: #000;
  }

  .expanded-status-box.has-offer-actions {
    padding: 8px 6px;
  }

  .offer-actions {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    align-items: center;
    justify-content: center;
    width: max-content;
    max-width: 100%;
    gap: 6px;
  }

  .offer-btn {
    border: none;
    border-radius: 8px;
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    cursor: pointer;
    width: 100%;
    white-space: nowrap;
  }

  .offer-btn.accept {
    background: #4caf50;
    color: #fff;
  }

  .offer-btn.decline {
    background: #e53935;
    color: #fff;
  }

  .no-result {
    text-align: center;
    padding: 32px 8px;
  }

  @media (max-width: 900px) {
    .application-row-main {
      grid-template-columns: 1fr auto;
      row-gap: 10px;
    }

    .application-job {
      grid-column: 1 / 2;
    }

    .expand-btn {
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    }

    .application-employer {
      grid-column: 1 / 2;
    }

    .application-status {
      grid-column: 1 / 3;
      justify-content: flex-start;
    }

    .application-row-details {
      flex-wrap: wrap;
      row-gap: 12px;
    }
  }
</style>

<style>
  .page_content_container:has(.job-applications-page) {
    overflow: hidden;
    padding-bottom: 0;
  }

  .job-applications-page .sort_by_popover .popover,
  .job-applications-page .explore_filter_container .popover {
    transform: none !important;
    top: 42px !important;
    margin: 0 !important;
    min-width: 240px;
  }

  .job-applications-page .explore_filter_container .popover .popover-body {
    padding-top: 12px;
  }

  .job-applications-page .sort_by_popover .popover {
    top: 2px !important;
    left: auto !important;
    right: 0 !important;
  }

  .job-applications-page .explore_filter_container .popover {
    left: 0 !important;
    right: auto !important;
  }

  .job-applications-page .explore_filter_container .popup_content {
    overflow: auto;
    max-height: calc(100vh - 360px);
    padding: 0 12px 8px;
  }

  .job-applications-page .explore_filter_container .popup_content .input-search {
    width: 100%;
    height: 32px;
    margin: 0 0 8px;
    padding: 0 8px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/MyJobApplications.vue